var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeclined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0Z",
    fill: "#E82626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83265 6.43807C7.4474 6.05282 6.82279 6.05282 6.43754 6.43807C6.0523 6.82332 6.0523 7.44793 6.43754 7.83317L6.48824 7.88387L10.6049 12.0005L6.76714 15.8382L6.43754 16.1678C6.0523 16.553 6.0523 17.1777 6.43754 17.5629C6.82279 17.9482 7.4474 17.9482 7.83265 17.5629L12 13.3956L16.1673 17.5629C16.5525 17.9482 17.1771 17.9482 17.5624 17.5629C17.9476 17.1777 17.9476 16.5531 17.5624 16.1678L13.3951 12.0005L17.5624 7.83317C17.9476 7.44793 17.9476 6.82332 17.5624 6.43807C17.1771 6.05283 16.5525 6.05283 16.1673 6.43807L12 10.6054L7.83265 6.43807Z",
    fill: "#E82626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclined);
export default __webpack_public_path__ + "static/media/Declined.228923d603a7cffac55273f702c7a663.svg";
export { ForwardRef as ReactComponent };